<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>

    <filter-manager
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync"
      search-text="Procesar"
      search-container-class="btn-process"
      v-model="model.search.filters"
      :filters="filterManagerConfig"
      @search="onHandlerSearch"
      ref="filterRef"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import SpecialistServices from '@/services/api/specialist.api'
import ProviderServices from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Informe de Supervisados',
      routes: ['Informes', 'Informe de Supervisados'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          specialists: [],
          practitioners: [],
          providers: [],
          specialties: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          specialist: null,
          specialty: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          class: 'col-md-3',         
          onChanged: this.onChangeProvider,
        },
        {
          name: 'specialist',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialista',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialists,
          value: this.model.search.filters.specialist,
          class: 'col-md-3',         
          onChanged: this.onChangeSpecialist,
        },
        {
          name: 'specialty',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Especialidad',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.specialties,
          value: this.model.search.filters.specialty,
          class: 'col-md-3',                   
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears().then(
        (res) => (this.model.search.collections.academicYears = res.data)
      )
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      this.model.search.filters.specialist = null
      this.model.search.filters.specialty = null
      await this.getProvider()
      await this.getActiveSpecialists()
      await this.getSpecialtyTypes()
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null
      if(this.model.search.filters.provider != null){
        await this.getSpecialist()
      } else {
         await this.getActiveSpecialists()
      }  
    },
    async onChangeSpecialist() {
      this.model.search.filters.specialty = null
      if(this.model.search.filters.specialist != null){
         await this.getSpecialty()
      } else {
         await this.getSpecialtyTypes()
      }  
     
    },
    async getProvider() {
      await ProviderServices.getAllProvidertCompaniesByYear({
        academicYearId: this.model.search.filters.academicYear?.id,
      }).then((res) => {
        this.model.search.collections.providers = res.data

        if (res.data.length == 1) {
          this.model.search.filters.provider = res.data[0]
          this.getSpecialist()
        }
      })
    },
    async getSpecialist() {
      await SpecialistServices.getSpecialistProvider({
        academicYearId: this.model.search.filters.academicYear?.id,
        companyId: this.model.search.filters.provider?.id
      }).then((res) => {
        this.model.search.collections.specialists = res.data;
      })
    },
    async getSpecialty() {
      await SpecialistServices.getSpecialties(this.model.search.filters.specialist?.id)
      .then((res) => {
        this.model.search.collections.specialties = res.data;

        if (res.data.length == 1) {
          this.model.search.filters.specialty = res.data[0];
        }
      })
    },
    async getActiveSpecialists() {
      await SpecialistServices.getActiveSpecialists(this.model.search.filters.academicYear?.id)
      .then((res) => {
        this.model.search.collections.specialists = res.data;        
      })
    },
    async getSpecialtyTypes(){
      await SpecialistServices.getSpecialtyTypes()
      .then((res) => {
        this.model.search.collections.specialties = res.data;        
      })
    },
    async onHandlerSearch() {
      this.process()
    },
    async process() {
      if (this.hasValue(this.model.search.filters.academicYear?.id)) {
        await ReportServices.getReport('supervised', {
          academicYearId: this.model.search.filters.academicYear?.id,
          companyId: this.model.search.filters.provider?.id,
          specialistId: this.model.search.filters.specialist?.id,
          disciplineTypeId: this.model.search.filters.specialty?.id,
        }).then((res) => DocumentServices.Download(res.data))
      }
    },
  },
}
</script>
